import FORM_CONTEXT_PHYSICAL_WORLD from '../forms-context.enum'

const FORM_RECEIVERS = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_RECEIVERS,
  disabled: false
}
const FORM_ADDRESS = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_ADDRESS,
  disabled: false
}

const FORM_OPEN_HOURS = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_OPEN_HOURS,
  disabled: false
}

const FORM_OBSERVATION = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_OBSERVATION,
  disabled: false
}

const FORM_ROLL_QUANTITY = {
  name: FORM_CONTEXT_PHYSICAL_WORLD.FORM_ROLL_QUANTITY,
  disabled: false
}

export {
  FORM_ADDRESS,
  FORM_RECEIVERS,
  FORM_OBSERVATION,
  FORM_OPEN_HOURS,
  FORM_ROLL_QUANTITY
}
